<div class="text" *ngIf="!this.isError && !this.isLoading">
    <div class="text" class="breadcrumbs">
        <span class="title">Lista DPGR
            <mat-icon style="vertical-align: middle;">keyboard_arrow_right
            </mat-icon> Lista invio segnalazioni DPGR
            <mat-icon style="vertical-align: middle;">keyboard_arrow_right
            </mat-icon> Dettaglio segnalazione {{dataToRender.descrizione}}
        </span>
    </div>
    <hr>
    <div class="text" class="titolo flex-display">
        <span class="h1 upp">Dettaglio segnalazione {{dataToRender.descrizione}}</span>
    </div>
    <div class="detailSegnalazioneBox">
        <span class="h3">ID invio</span>
        <div class="text">{{dataToRender.idInvio}}</div>

        <span class="h3">Data Creazione</span>
        <div class="text">{{dataToRender.dataCreazione | date: 'dd/MM/yyyy'}}</div>

        <span class="h3">Stato</span>
        <div class="text">{{dataToRender.stato}}</div>

        <span class="h3">File Caricato</span>
        <div class="text">{{dataToRender.fileCaricato ? "SI" : "NO"}}</div>

        <span class="h3">Denominazione</span>
        <div class="text">{{dataToRender.denominazione}}</div>

        <span class="h3">Stato segnalazione</span>
        <div class="text">{{dataToRender.stato_segnalazione }}</div>

        <span class="h3">Data Segnalazione</span>
        <div class="text">{{dataToRender.dataSegnalazione | date: 'dd/MM/yyyy'}}</div>

        <span class="h3">Numero Protocollo Ente Attuatore</span>
        <div *ngIf="!!dataToRender.numProtoEnteAt" class="text">{{dataToRender.numProtoEnteAt}}</div>
        <div *ngIf="!dataToRender.numProtoEnteAt" class="text">-</div>

        <span class="h3">Data Protocollo Ente Attuatore</span>
        <div *ngIf="!!dataToRender.dataProtoEnteAt" class="text">{{dataToRender.dataProtoEnteAt | date:'dd/MM/yyyy'}}
        </div>
        <div *ngIf="!dataToRender.dataProtoEnteAt" class="text">-</div>

        <span class="h3">Numero Protocollo RVE</span>
        <div *ngIf="!!dataToRender.numProtoRve" class="text">{{dataToRender.numProtoRve}}</div>
        <div *ngIf="!dataToRender.numProtoRve" class="text">-</div>

        <span class="h3">Data Protocollo RVE</span>
        <div *ngIf="!!dataToRender.dataProtoRve; else emptyDataProtoRve" class="text">{{dataToRender.dataProtoRve
            | date: 'dd/MM/yyyy'}}</div>
        <div *ngIf="!dataToRender.dataProtoRve; else emptyDataProtoRve" class="text">-</div>
    </div>
    <br>
    <div class="text" class="titolo flex-display">
        <span class="h1 upp">Contenuto segnalazione {{dataToRender.descrizione}}</span>
    </div>

    <mat-table matSort [dataSource]="this.dataSource" matSortActive="codiceSegnalazione" matSortDirection="desc"
        matSortDisableClear>

        <ng-container matColumnDef="codiceSegnalazione">
            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> Codice segnalazione </mat-header-cell>
            <mat-cell [attr.data-label]="'Codice segnalazione'" *matCellDef="let element">
                {{element.codiceSegnalazione}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tipoRichiesta">
            <mat-header-cell *matHeaderCellDef> Tipo richiesta</mat-header-cell>
            <mat-cell [attr.data-label]="'Tipo richiesta'" *matCellDef="let element">
                <span *ngIf="element.tipoRichiesta == 1">Richieste danni di tipo pubblico</span>
                <span *ngIf="element.tipoRichiesta == 2">Richieste danni di tipo privato</span>
                <span *ngIf="element.tipoRichiesta == 3">Richieste danni di tipo attività economiche</span>
                <span *ngIf="element.tipoRichiesta == 4">Modello libero</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="descrizioneSegnalazione">
            <mat-header-cell *matHeaderCellDef> Descrizione segnalazione </mat-header-cell>
            <mat-cell [attr.data-label]="'Descrizione segnalazione'" *matCellDef="let element">
                {{element.descrizioneSegnalazione}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="stato">
            <mat-header-cell *matHeaderCellDef> Stato </mat-header-cell>
            <mat-cell [attr.data-label]="'Stato'" *matCellDef="let element">
                <span *ngIf="element.stato == 'BOZ'">In bozza</span>
                <span *ngIf="element.stato == 'COM'">Completata</span>
                <span *ngIf="element.stato == 'INV'">Inviata</span>
                <span *ngIf="element.stato == 'RIC'">Ricevuta</span>
                <span *ngIf="element.stato == 'NOR'">Non ricevuta</span>
                <span *ngIf="element.stato == 'CON'">Confermata</span>
                <span *ngIf="element.stato == 'RIF'">Rifiutata</span>
                <span *ngIf="element.stato == 'IDI'">Inviata al dipartimento</span>
                <span *ngIf="element.stato == 'ENR'">Emergenza non riconosciuta</span>
                <span *ngIf="element.stato == 'IDG'">Inviata a DGPE</span>
                <span *ngIf="element.stato == 'BPE'">In bozza post emergenza</span>
                <span *ngIf="element.stato == 'APP'">Apertura post emergenza</span>
                <span *ngIf="element.stato == 'INP'">Inviata post emergenza</span>
                <span *ngIf="element.stato == 'CHI'">Chiusa post emergenza</span>
                <span *ngIf="element.stato == 'RIP'">Ricevuta post emergenza</span>
                <span *ngIf="element.stato == 'COP'">Completata post emergenza</span>
                <span *ngIf="element.stato == 'CNP'">Confermata post emergenza</span>
                <span *ngIf="element.stato == 'RFP'">Rifiutata post emergenza</span>
                <span *ngIf="element.stato == 'IPE'">Inviata al dipartimento post emergenza</span>
                <span *ngIf="element.stato == 'IDP'">Inviata al dipartimento DGPE post emergenza</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="flRettificata">
            <mat-header-cell *matHeaderCellDef>Rettificata</mat-header-cell>
            <mat-cell [attr.data-label]="'Rettificata'" *matCellDef="let element">
                <span *ngIf="element.flRettificata == 'S'">Sì</span>
                <span *ngIf="element.flRettificata == 'N'">No</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="identificativoInvio">
            <mat-header-cell *matHeaderCellDef>Identificativo invio</mat-header-cell>
            <mat-cell [attr.data-label]="'Identificativo invio'" *matCellDef="let element">
                {{element.identificativoInvio}}
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
</div>

<div class="text" data-loadable class="favourites-loader"></div>
